import {
  Admin,
  CustomRoutes,
  Layout,
  Menu,
  MenuItemLink,
  Resource,
  defaultTheme,
  useCreatePath,
  useGetResourceLabel,
  useResourceDefinitions,
} from "react-admin";

import DefaultIcon from "@mui/icons-material/ViewList";
import "./App.css";
import { ChildList } from "./components/child/ChildList";
import { ParentList } from "./components/parent/ParentList";
import { ReferralList } from "./components/referral/ReferralList";
import { StoryCreate } from "./components/story/StoryCreate";
import { StoryList } from "./components/story/StoryList";
import { StoryShow } from "./components/story/StoryShow";
import dataProvider from "./provider/provider";
// import { PharmacyCreate } from "./components/pharmacy/PharmacyCreate";
import { Route } from "react-router-dom";
import {
  AppSettingsCreate,
  AppSettingsEdit,
  AppSettingsList,
  AppSettingsShow,
  UploadBanner,
} from "./components/appSettings";
import { CouponList } from "./components/coupon/CouponList";
import { DoctorEdit } from "./components/doctor/DoctorEdit";
import { DoctorList } from "./components/doctor/DoctorList";
import { DoctorShow } from "./components/doctor/DoctorShow";
import { EventCreate } from "./components/events/create";
import { EventEdit } from "./components/events/edit";
import { EventList } from "./components/events/list";
import { EventShow } from "./components/events/show";
import { BulkNotifications } from "./components/notification/bulkNotification";
import { PaintingCreate } from "./components/painting/create";
import { PaintingEdit } from "./components/painting/edit";
import { PaintingList } from "./components/painting/list";
import { PaintingShow } from "./components/painting/show";
import { PharmacyList } from "./components/pharmacy/PharmacyList";
import { PharmacyShow } from "./components/pharmacy/PharmacyShow";
import authProvider from "./provider/authProvider";

import {
  Baby,
  BellDot,
  BookImage,
  BriefcaseMedical,
  Brush,
  CirclePercent,
  Cog,
  FileClock,
  GalleryThumbnails,
  GlobeIcon,
  ImageUp,
  ListIcon,
  Sparkle,
  SquareGanttChart,
  Stethoscope,
  TicketCheck,
  Trophy,
  UserRound,
  Video,
  Waypoints
} from "lucide-react";
import { AchievementCreate } from "./components/achievement/create";
import { AchievementEdit } from "./components/achievement/edit";
import { AchievementList } from "./components/achievement/list";
import { AchievementShow } from "./components/achievement/show";
import {
  ChildMomentCreate,
  ChildMomentEdit,
  ChildMomentList,
  ChildMomentShow,
} from "./components/childMoment";
import {
  ContestCreate,
  ContestEdit,
  ContestList,
  ContestShow,
} from "./components/contest";
import {
  ContestSubmissionCreate,
  ContestSubmissionEdit,
  ContestSubmissionList,
  ContestSubmissionShow,
} from "./components/contestSubmission";
import {
  ContestWinnerCreate,
  ContestWinnerEdit,
  ContestWinnerList,
  ContestWinnerShow,
} from "./components/contestWinner";
import { FaqCreate } from "./components/faq/create";
import { FaqEdit } from "./components/faq/edit";
import { FaqList } from "./components/faq/list";
import { InAppAdsCreate } from "./components/inappAds/create";
import { InappEdit } from "./components/inappAds/edit";
import { InAppAdsList } from "./components/inappAds/list";
import {
  MomentCreate,
  MomentEdit,
  MomentList,
  MomentShow,
} from "./components/moment";
import { CreateSeo } from "./components/seo/create";
import { EditSeo } from "./components/seo/edit";
import { SeoList } from "./components/seo/list";
import { YoutubeVideoCreate } from "./components/youtubeVideo/YoutubeVideoCreate";
import { YoutubeVideoEdit } from "./components/youtubeVideo/YoutubeVideoEdit";
import { YoutubeVideoList } from "./components/youtubeVideo/YoutubeVideoList";

const color = "#fb46f5";

const theme = {
  ...defaultTheme,
  palette: {
    background: {
      default: "#fafafb",
    },
    primary: {
      light: "#F1FCD7",
      main: "#3C4D44",
      dark: "#3C4D44",
      contrastText: "#fff",
    },
    secondary: {
      light: "#F1FCD7",
      main: "#A3B770",
      dark: "#3C4D44",
      contrastText: "#fff",
    },
  },
  components: {
    ...defaultTheme.components,
    MuiButtonBase: {
      variants: [
        {
          props: { variant: "contained", color: "primary" },
          style: {
            color: "white",
            background: "#3C4D44",
          },
        },
      ],
    },
  },
};

const MyMenu = (props) => {
  const resources = useResourceDefinitions();
  const createPath = useCreatePath();
  const getResourceLabel = useGetResourceLabel();

  return (
    <Menu {...props}>
      {Object.keys(resources)
        .filter((name) => resources[name].hasList)
        .map((name) => (
          <MenuItemLink
            key={name}
            to={createPath({
              resource: name,
              type: "list",
            })}
            state={{ _scrollToTop: true }}
            primaryText={getResourceLabel(name, 2)}
            leftIcon={
              resources[name].icon ? resources[name].icon : <DefaultIcon />
            }
          />
        ))}
      <Menu.Item
        to="/notification"
        primaryText="Notifications"
        leftIcon={<BellDot color={color} strokeWidth={1.5} />}
      />
      <Menu.Item
        to="/banner"
        primaryText="Banner"
        leftIcon={<GalleryThumbnails color={color} strokeWidth={1.5} />}
      />
      {/* <Menu.Item
        to="/parent"
        primaryText="Parents"
        // leftIcon={<GiMeshNetwork style={{ color: "#fd5f14" }} />}
      />
      <Menu.Item
        to="/child"
        primaryText="Children"
        // leftIcon={<BsCalendarMonth style={{ color: "#fd5f14" }} />}
      />
      <Menu.Item
        to="/story"
        primaryText="Stories"
        // leftIcon={<MdOutlineAnalytics style={{ color: "#fd5f14" }} />}
      />
      <Menu.Item
        to="/pharmacy"
        primaryText="Pharmacies"
        // leftIcon={
        //   <HiOutlineClipboardDocumentList style={{ color: "#fd5f14" }} />
        // }
      />
      <Menu.Item
        to="/doctors"
        primaryText="Doctors"
        // leftIcon={<CiMemoPad style={{ color: "#fd5f14" }} />}
      /> */}
    </Menu>
  );
};

const MyLayout = (props) => <Layout {...props} menu={MyMenu} />;

const App = () => {
  return (
    <Admin
      theme={theme}
      dataProvider={dataProvider}
      authProvider={authProvider}
      layout={MyLayout}
    >
      <Resource
        name="parent"
        // create={CityCreate}
        list={ParentList}
        // show={CityShow}
        // edit={CityEdit}
        icon={<UserRound color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="child"
        // create={CityCreate}
        list={ChildList}
        // show={CityShow}
        // edit={CityEdit}
        icon={<Baby color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="story"
        create={StoryCreate}
        list={StoryList}
        show={StoryShow}
        // edit={CityEdit}
        icon={<FileClock color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="pharmacy"
        // create={PharmacyCreate}
        list={PharmacyList}
        show={PharmacyShow}
        // edit={CityEdit}
        icon={<BriefcaseMedical color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="doctors"
        // create={PharmacyCreate}
        list={DoctorList}
        show={DoctorShow}
        edit={DoctorEdit}
        icon={<Stethoscope color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="coupon"
        // create={PharmacyCreate}
        list={CouponList}
        icon={<CirclePercent color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="event"
        edit={EventEdit}
        list={EventList}
        create={EventCreate}
        show={EventShow}
        icon={<TicketCheck color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="achievement"
        edit={AchievementEdit}
        list={AchievementList}
        create={AchievementCreate}
        show={AchievementShow}
        icon={<TicketCheck color={color} strokeWidth={1.5} />}
      />

      <Resource
        name="painting"
        edit={PaintingEdit}
        list={PaintingList}
        create={PaintingCreate}
        show={PaintingShow}
        options={{ label: "Paintings & Pictures" }}
        icon={<BookImage color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="referral"
        // create={PharmacyCreate}
        list={ReferralList}
        icon={<Waypoints color={color} strokeWidth={1.5} />}
      />

      <Resource
        name="contest"
        edit={ContestEdit}
        list={ContestList}
        create={ContestCreate}
        show={ContestShow}
        icon={<Brush color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="contestSubmission"
        edit={ContestSubmissionEdit}
        list={ContestSubmissionList}
        create={ContestSubmissionCreate}
        show={ContestSubmissionShow}
        options={{ label: "Contest Submissions" }}
        icon={<ImageUp color={color} strokeWidth={1.5} />}
      />

      <Resource
        name="contestWinner"
        list={ContestWinnerList}
        edit={ContestWinnerEdit}
        show={ContestWinnerShow}
        create={ContestWinnerCreate}
        options={{ label: "Contest Winners" }}
        icon={<Trophy color={color} strokeWidth={1.5} />}
      />

      <Resource
        name="moment"
        edit={MomentEdit}
        list={MomentList}
        create={MomentCreate}
        show={MomentShow}
        icon={<Sparkle color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="childMoment"
        list={ChildMomentList}
        edit={ChildMomentEdit}
        create={ChildMomentCreate}
        show={ChildMomentShow}
        options={{ label: "Child Moments" }}
        icon={<SquareGanttChart color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="inappAds"
        list={InAppAdsList}
        create={InAppAdsCreate}
        edit={InappEdit}
        options={{ label: "In-app ads" }}
        icon={<SquareGanttChart color={color} strokeWidth={1.5} />}
      />

      <Resource
        name="seo"
        options={{ label: "SEO" }}
        list={<SeoList />}
        create={<CreateSeo />}
        edit={<EditSeo />}
        icon={<GlobeIcon color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="altilium-seo"
        list={<SeoList />}
        create={<CreateSeo />}
        options={{ label: "Altilium SEO" }}
        edit={<EditSeo />}
        icon={<GlobeIcon color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="faq"
        options={{ label: "FAQ" }}
        list={<FaqList />}
        create={<FaqCreate />}
        edit={<FaqEdit />}
        icon={<ListIcon color={color} strokeWidth={1.5} />}
      />

      <CustomRoutes>
        <Route path="/notification" element={<BulkNotifications />} />
      </CustomRoutes>
      {/* <CustomRoutes>
        <Route path="notification/fcm/all" element={<BulkNotifications />} />
  </CustomRoutes> */}
      <CustomRoutes>
        <Route path="banner" element={<UploadBanner />} />
      </CustomRoutes>
      <Resource
        name="appSettings"
        edit={AppSettingsEdit}
        list={AppSettingsList}
        create={AppSettingsCreate}
        show={AppSettingsShow}
        options={{ label: "App Settings" }}
        icon={<Cog color={color} strokeWidth={1.5} />}
      />
      <Resource
        name="youtube-video"
        edit={YoutubeVideoEdit}
        list={YoutubeVideoList}
        create={YoutubeVideoCreate}
        options={{ label: "Youtube Video" }}
        icon={<Video color={color} strokeWidth={1.5} />}
      />
    </Admin>
  );
};

export default App;
